import React, { FC, useState, useEffect } from 'react';
import ChipInput from 'material-ui-chip-input';
import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { userInvite, getReferralInfo } from 'actions/payments';
import invitationToAneta from 'components/email-templates/invitationtoAneta';
import { connect, useDispatch } from 'react-redux';
import { IRootState } from 'store';
import _ from 'lodash';
import CloseIcon from 'style/imgs/icons/close-chip.svg';
import SendIcon from 'style/imgs/icons/send-chip.svg';
import Robot from 'style/imgs/referr.svg';
import RadiusInput from 'components/common/formElements/radiusInput';
import buttons from 'style/buttons.module.scss';
import Title from 'components/common/Title';
import { selectReferralInfo } from 'selectors/payments';
import style from './index.module.scss';

const mstp = (state: IRootState) => ({
  currentUserEmail: state.users.userData?.email,
  errorMessage: state.payments.referralsErrors,
  referralInfo: selectReferralInfo(state),
  userId: state.users.userData?.id,
});

type Props = ReturnType<typeof mstp>;

const Scholars: FC<Props> = ({
  currentUserEmail,
  errorMessage,
  referralInfo,
  userId,
}) => {
  const dispatch = useDispatch();

  const [inputTags, setInputTags] = useState<string[]>([]);
  const [activeTab, setActiveTab] = useState(1);
  const [referralLink] = useState(
    `${window.location.origin}/sign-up/${userId}`
  );

  useEffect(() => {
    dispatch(getReferralInfo());
  }, [dispatch]);

  const changeTab = (tab: number) => {
    setActiveTab(tab);
  };
  const handleAddChip = (chip: string) => {
    setInputTags([...inputTags, chip.trim()]);
  };

  const handleDeleteChip = (chip: string) => {
    setInputTags(_.without(inputTags, chip));
  };
  const useStyles = makeStyles(() => ({
    root: {
      borderRadius: '28px',
      boxShadow: 'none',
      boxSizing: 'border-box',
      // [`& fieldset`]: {
      //   background: 'rgb(232 255 254)',
      // },
      [`& label`]: {
        background: '#fff',
        paddingRight: '20px',
      },
    },
    chipInput: {
      display: 'block',
      minWidth: '80%',
    },
  }));
  const classes = useStyles();

  const handleSubmit = async () => {
    if (currentUserEmail) {
      const params = {
        html: invitationToAneta(currentUserEmail, referralLink),
        emails: inputTags,
      };
      await dispatch(userInvite(params));
    }
    setInputTags([]);
  };

  return (
    <div className={style.wrapper}>
      <Title>Welcome Back</Title>
      <div className={style.buttonsBlock}>
        <button
          onClick={() => changeTab(1)}
          type="button"
          className={
            activeTab === 1 ? buttons.buttonOrange : buttons.buttonWhite
          }
        >
          Referrals
        </button>
        <button
          onClick={() => changeTab(2)}
          type="button"
          className={
            activeTab === 1 ? buttons.buttonWhite : buttons.buttonOrange
          }
        >
          Rewards
        </button>
      </div>
      <div className={style.content}>
        {activeTab === 1 ? (
          <>
            <div className={style.content_left}>
              <Title>Refer Aneta and Win Rewards!</Title>
              <RadiusInput
                variant="outlined"
                type="email"
                label="Your Email"
                name="email"
                value={currentUserEmail}
              />
              <div className={style.recipientAddress}>
                <h4>Recipient&apos;s address(es):</h4>
                <p>
                  I’m using Aneta to manage and organize screen time for the
                  kids and get recommendations for fun and productive digital
                  content.
                </p>
                <span>Sign up at AnetaEd.com and try it free.</span>
                <ChipInput
                  variant="outlined"
                  label="Recipients' emails"
                  value={inputTags}
                  onAdd={(chip) => handleAddChip(chip)}
                  onDelete={(chip) => handleDeleteChip(chip)}
                  className={`${classes.root} ${style.emailInput}`}
                  disableUnderline
                  classes={{
                    input: classes.chipInput,
                  }}
                  chipRenderer={(
                    {
                      value,
                      isDisabled,
                      isReadOnly,
                      handleClick,
                      handleDelete,
                    },
                    key
                  ) => (
                    <Chip
                      key={key}
                      style={{
                        pointerEvents:
                          isDisabled || isReadOnly ? 'none' : undefined,
                        background:
                          'linear-gradient(360deg, #f5781e29 0%, #ffa7482e 100%)',
                        borderRadius: '15px',
                        display: 'grid',
                        gridTemplateColumns: '20px 1fr 20px',
                        alignItems: 'center',
                        color: ' #5F5577',
                        fontFamily: 'Proxima Nova Rg',
                        marginRight: '10px',
                      }}
                      onClick={handleClick}
                      onDelete={handleDelete}
                      label={value}
                      deleteIcon={
                        <div>
                          <img src={CloseIcon} alt="" />
                        </div>
                      }
                      avatar={
                        <div>
                          <img src={SendIcon} alt="" />
                        </div>
                      }
                    />
                  )}
                />
              </div>
              {errorMessage && (
                <span className="error-message">{errorMessage}</span>
              )}
              <button
                type="button"
                className={`${buttons.buttomPrimary} ${style.buttonSend}`}
                onClick={handleSubmit}
              >
                Send
              </button>
              <div className={style.copyLinkArea}>
                <span title={referralLink}>{referralLink}</span>
                <button
                  onClick={() => {
                    navigator.clipboard.writeText(referralLink);
                  }}
                  type="button"
                  className={buttons.buttonOrange}
                >
                  Copy invite link
                </button>
              </div>
            </div>
            <div className={style.content_right}>
              <span>
                One month free ($6.99 value) for each referral that turns into
                an Aneta subscription!
              </span>
            </div>
          </>
        ) : (
          <div className={style.rewards}>
            <Title>Track your Referral Rewards</Title>
            {referralInfo && (
              <div className={style.applyTimes}>
                <div>
                  <div>{referralInfo.requestsSent}</div>
                  <span>Referrals sent</span>
                </div>
                <div>
                  <div>{referralInfo.requestsAccepted}</div>
                  <span>Referee sign ups</span>
                </div>
              </div>
            )}
            <span>{`You have earned ${referralInfo?.requestsAccepted} months of Aneta free!`}</span>
            {referralInfo && (
              <div className={style.chart}>
                <div
                  style={{
                    width: `${referralInfo?.requestsAccepted * 8.33 + 8.33}%`,
                  }}
                  className={style.progress}
                />
                <img src={Robot} alt="Robot" />
              </div>
            )}
            <div className={style.refCount}>
              <div>0</div>
              <div>1</div>
              <div>2</div>
              <div>3</div>
              <div>4</div>
              <div>5</div>
              <div>6</div>
              <div>7</div>
              <div>8</div>
              <div>9</div>
              <div>10</div>
              <div>11</div>
            </div>
            <span>Free subscription Months earned</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default connect(mstp)(Scholars);
